import { render } from "./ImportDetailPriceLists.vue?vue&type=template&id=15b1d90a&scoped=true"
import script from "./ImportDetailPriceLists.vue?vue&type=script&lang=js"
export * from "./ImportDetailPriceLists.vue?vue&type=script&lang=js"

import "./ImportDetailPriceLists.vue?vue&type=style&index=0&id=15b1d90a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b1d90a"]])

export default __exports__